import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../hooks/hooks";
import { selectGlobalDBARegistriesListItems } from "../../../../redux/global-dba-registries/selector";
import { globalDBARegistries } from "../../../../redux/global-dba-registries/action";
import PageLoader from "../../../../components/PageLoader";
import Table from "../../../../common/components/table";

const GlobalDBARegistries = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
    const dbasItems = useSelector(selectGlobalDBARegistriesListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Name', headerName: 'Name', searchField: 'Name', filter: true,
            filterType: 'text' },
            { field: 'DBNIEName', headerName: 'DBNIE Name'},
          { field: 'DBNPName', headerName: 'DBNP Name'},
          {field: 'DBNPRegistryName', headerName: 'DBNP Registry Name'},
          {field: 'OrgRegistryName', headerName: 'OrgRegistry Name'},
            { field: 'Types', headerName: 'Type',  filterType: 'text' },
      { field: 'Description', headerName: 'Description',  filterType: 'text' },
        ]);
      }

      const handleSearch = (data: any) => {
        console.log('Search data', data)
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        dispatch(globalDBARegistries.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/global-dba-registries/fetch`,entity:'globalDBARegistries',jsonData:{
       "Context": {},
  "Records" : [{}],
  "Pagination":{
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          "Searches": searchCriteria,
  }
          }}))
      }
      const handleReloadData = () => {
        dispatch(globalDBARegistries.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/global-dba-registries/fetch`,entity:'globalDBARegistries',jsonData:{
       "Context": {},
  "Records" : [{}],
  "Pagination":{
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
  }
      
          }}))
      }
      const filterTypes = [{
        name: 'Text', value: "text"
      },
      {
        name: 'Number', value: "number"
      },
      {
        name: 'CheckBox', value: "checkbox"
      },
      {
        name: 'Date', value: "date"
      }
      ]
     
      const fetchDbas=()=>{
        dispatch(globalDBARegistries.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/global-dba-registries/fetch`,entity:'globalDBARegistries',jsonData:{
      
         "Context": {},
  "Records" : [{}],
  "Pagination":{
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
  }
        
    
        }}))
      }
      const handleEdit=(data: any)=>{
       navigate(`${data.GlobalDBARegistryId}`)
      }
	useEffect(() => {
        createColumnDefs()
        fetchDbas()
	}, [pageData,pageSize])
    const additionButtons: any = [
        {
          svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        // name: 'Reload',
        callback: () => handleReloadData(),
        },
      ];
	return (
    <>
    {dbasItems?.isLoading ?  <PageLoader />: 
		<Table  enableFilter={true}
    filterTypeLists={filterTypes}  setPageSize={setPageSize}
    onSearch={handleSearch} columnData={columnDefs} rowData={dbasItems?.result?.items} setPageData={setPageData}
    paginationData={dbasItems?.result?.pagination} onEdit={handleEdit} additionButtons={additionButtons} headingName="Global DBA Registries"/>
     
  }
  </> 
	);
};

export default GlobalDBARegistries;


